<template>
    <div>
        <!-- <a-card title="知识讲堂" :bordered='false'> -->
            <div class="btn-wrap">
                <div class="search-list" style="display:flex;align-items: center;">
                    <a-input-group compact style="margin-right:20px">
                        <a-range-picker @change="changDate" :format="dateFormat"  v-model:value="time" />
                    </a-input-group>
                    <a-input style="margin-right:20px" v-model:value="order_no" placeholder="请输入订单号"/>
                    <!-- <a-input style="margin-right:20px" v-model:value="telephone" placeholder="请输入手机号码"/> -->

                    <a-button type="primary" @click="toSearch">搜索</a-button>
                    <!-- <a-button type="primary" @click="openAdd"><template #icon><plus-outlined /></template>添加患者</a-button>
                    <a-button type="danger" @click="delMore"><template #icon><delete-outlined /></template>删除</a-button> -->
                </div>
                <!-- <div>
                    <a-input-group compact>
                        <a-input v-model:value="search"  placeholder="请输入患者姓名"/>
                        <a-button type="primary" @click="toSearch">搜索</a-button>
                    </a-input-group>
                </div> -->
            </div>

            <a-table row-key="id" :pagination="false" :columns="columns" :data-source="dataList.arr"  >
                <template #bodyCell="{ column,record}">
                    <template v-if="column.dataIndex === 'end_time'">
                        <span v-if="record.end_time==0"></span>
                        <span v-else>{{record.end_time}}</span>
                    </template>

                    <template v-if="column.dataIndex === 'order_status '">
                        <span v-if="record.order_status==0"><a-tag color="processing">待付款</a-tag></span>
                        <span v-if="record.order_status==1"><a-tag color="success">已付款</a-tag></span>
                        <span v-if="record.order_status==2"><a-tag color="warning">已关闭</a-tag></span>
                        <span v-if="record.order_status==3"><a-tag color="error">已过期</a-tag></span>
                    </template>
                    <template v-if="column.dataIndex === 'status '">
           
                        <span v-if="record.order_status==1"><a-tag color="success">可用</a-tag></span>
                        <span v-else><a-tag color="error">不可用</a-tag></span>
                    </template>
                    <!-- <template v-if="column.dataIndex === 'operation'">
                        <a-button type="link" @click="openEdit(record.id)">编辑</a-button>
                        <a-button type="link" @click="del(record.id)">删除</a-button>
                    </template> -->
                </template>
            </a-table>

            <a-pagination
                v-model:pageSize="page.pageSize"
                show-size-changer
                :total="page.total"
                @change="pageChange"
                :show-total="total => `共 ${total} 条数据`"
            />
        <!-- </a-card> -->

    </div>
</template>


<script>
import { reactive,ref,computed } from 'vue';

import { getCurrentInstance } from 'vue'
import { message} from 'ant-design-vue';
import moment from 'moment';
import { formatDate } from "../../common/filter.js";
const columns = [
    {title: 'ID',dataIndex: 'id',width:90},

    {title: '用户ID',dataIndex: 'user_id',width:90},
    {title: '订单号',dataIndex: 'order_no',width:120},
    {title: '订单状态',dataIndex: 'order_status ',width:100},
    {title: '可用状态',dataIndex: 'status ',width:100},
    {title: '套餐',dataIndex: 'title_set_meal',width:110},
    {title: '订单金额',dataIndex: 'order_amount',width:100},
    {title: '总条数',dataIndex: 'total_no'},
    {title: '开始时间',dataIndex: 'create_time'},
    {title: '结束时间',dataIndex: 'end_time'},
];
export default {
    setup(){
        const changeFormdate = computed(() => {
            return (time) => {
                let date = new Date(time);
                return formatDate(date);
            };
        });
        const { proxy } = getCurrentInstance()
        let dataList=reactive({arr:[]})
        
        let page=reactive({page:"1",pageSize:"10",total:""})//分页

        var totalData=reactive({data:{}})
        var getTotalData=function(){
            proxy.$http.post('/admin/indexstatisticsall',{create_time:""},{
                headers:{
                    'token':sessionStorage.getItem("token")
                }
            }).then((res) => {
                if(res.data.status==200){
                    totalData.data=res.data.data
                }else{
                    message.error(res.data.msg);
                }
            });
        }
        getTotalData()

        // 搜索
        let search=ref()
        let username=ref()
        let toSearch=function(){
            page.page="1"
            getTabledata()
        }
        
        let order_no=ref()
        const dateFormat = ['YYYY-MM-DD', 'YYYY-MM-DD'];
        
        let create_time=ref()
        let changDate=function(date,string){
            console.log(string)
            if(string[0]){
                create_time.value=moment(string[0]+' 00:00:00').unix()+"-"+moment(string[1] +' 23:59:59').unix()
            }else{
                create_time.value=""
            }
            
        }
        // 列表
         let time=ref()
        let getTabledata=function(){
            proxy.$http.post('/admin/orderlist',{page:page.page,pagesize:page.pageSize,order_no:order_no.value,create_time:create_time.value},{
                headers:{
                    'token':sessionStorage.getItem("token")
                }
            }).then((res) => {
                if(res.data.status==200){
                    dataList.arr=res.data.data.data
                    page.total=res.data.data.total
                }else{
                    message.error(res.data.msg);
                }
            });
        }
        getTabledata()

    

        // 分页
        let pageChange=function(current, size){
            page.pageSize=size
            page.page=current
            getTabledata()
        }
        return{
            time,dateFormat,changDate,
            changeFormdate,totalData,
            toSearch,search,username,order_no,
            columns,dataList,pageChange,page
        }
    }
}
</script>